export enum CrudBehavior
{
  /**
      * Crud capability is not enabled
      */
  NoCrud,

  /**
      * List and CRUD form are displayed at the same time - no toggle between them
      */
  ListAndCrudTogether,

  /**
      * List and CRUD form are displayed separately, first List, then Crud, one hides, the other shows.
      * When a Crud operation (insert save, update save, delete, undelete, cancel) is done, the UI stays showing the record.
      */
  ListAndCrudSeparately,

  /**
      * List and CRUD form are displayed separately, first List, then Crud, one hides, the other shows.
      * Additionally - when a Crud operation (insert save, update save, delete, undelete, cancel) is done, it returns directly to the list.
      */
  ListAndCrudSeparately_ReturnToList,
}

export enum TableType
{
  None,
  Material
}

export class ListFormConfig
{
  public includesForGetAll: string;

  /**
      * Specifies the table type to use with the list.  Default: none
      */
  public tableype: TableType = TableType.Material;
  public enablePagination: boolean;
  public enableSort: boolean;

  /**
      * If true (default), then the data load is called when the view is first initialized.
      * If false, then data load is not called until some user activity / button triggers it.
      */
  public loadDataOnInitialize: boolean;
  public enableExportButton: boolean;
  public enableRefreshButton: boolean;


  public _enableAddButton: boolean;

  /**
      * If true, an Add Button is enabled for the list to support adding a record
      */
  public get enableAddButton(): boolean
  {
    if (this._enableAddButton) { return true; }
    else { return false; }
  }

  // ********************************************************************
  // Constructor
  // ********************************************************************

  constructor(public crudBehavior: CrudBehavior)
  {
    this.enableRefreshButton = true;
    this.loadDataOnInitialize = true;

    if (crudBehavior != CrudBehavior.NoCrud)
    {
      this._enableAddButton = true;
    }
  }

  // ********************************************************************
  // #region set
  // ********************************************************************

  public setIncludesForGetAll(value: string)
  {
    this.includesForGetAll = value;
    return this;
  }

  public setLoadDataOnInitialize(value: boolean = true)
  {
    this.loadDataOnInitialize = value;
    return this;
  }

  public setEnableExportButton(value: boolean = true)
  {
    this.enableExportButton = value;
    return this;
  }

  public setEnableRefreshButton(value: boolean = true)
  {
    this.enableRefreshButton = value;
    return this;
  }

  public setEnableAddButton(value: boolean = true)
  {
    this._enableAddButton = value;
    return this;
  }

  // #endregion
}
